module.exports = __webpack_public_path__ + "img/Recycled_material_1200x800.517b5fb2.png";